import React, { useEffect, useRef } from 'react'
import { Col, Row } from 'reactstrap'

const Videos = ({ fetchProduct }) => {

  const videoEl = useRef(null);

  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch(error => {
        console.error("Error attempting to play", error);
      });
  };

  useEffect(() => {
    attemptPlay();
  }, []);


  return (
    <div>
      <div
        className='w-100'
      // style={{ borderBottom: '1px solid rgb(217, 217, 217)', paddingBottom: '1rem' }}
      >
        <Row flex>
          {fetchProduct?.productVideos?.map(item => (

            <Col lg='3' md='4' sm='12' xs='12'>
              <video
                style={{ maxWidth: "100%", width: "800px", margin: "0 auto" }}
                playsInline
                loop
                controls
                alt="All the devices"
                src={item || "https://stream.mux.com/6fiGM5ChLz8T66ZZiuzk1KZuIKX8zJz00/medium.mp4"}
                ref={videoEl}
              />
            </Col>
          ))}

        </Row>

      </div>
    </div>
  )
}

export default Videos;